module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-nw.c43b3135.png";